import { render, staticRenderFns } from "./TemplateWidget.vue?vue&type=template&id=e9528290&scoped=true"
import script from "./TemplateWidget.vue?vue&type=script&lang=js"
export * from "./TemplateWidget.vue?vue&type=script&lang=js"
import style0 from "./TemplateWidget.vue?vue&type=style&index=0&id=e9528290&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9528290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9528290')) {
      api.createRecord('e9528290', component.options)
    } else {
      api.reload('e9528290', component.options)
    }
    module.hot.accept("./TemplateWidget.vue?vue&type=template&id=e9528290&scoped=true", function () {
      api.rerender('e9528290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/TemplateWidget.vue"
export default component.exports